import { getStyleStringFromObject } from 'helpers/getStyleStringFromObject';
import React, { useRef, useEffect } from 'react';

export const ReportTableCustomTableData = ({ style, styleString, children, attribute }) => {
    const tdRef = useRef<HTMLTableCellElement>(null);

    useEffect(() => {
        if (tdRef.current && (styleString || style)) {
            const concatStyle = (getStyleStringFromObject(style) ? getStyleStringFromObject(style) + ';' : '') + styleString;
            // console.log(concatStyle);
            tdRef.current.setAttribute('style', concatStyle);
        }

        if (tdRef.current && attribute) {
            attribute.forEach((attr) => {
                tdRef.current?.setAttribute(attr.key, attr.value);
            });
        }
    }, [styleString]);

    return <td ref={tdRef}>{children}</td>;
};